/**
 * @deprecated Use custom Skeletons instead
 **/
export default function Loader() {
  return (
    <div className="loader border-brand-default">
      <span className="loader-inner bg-brand" />
    </div>
  );
}
